import {
  Box,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Image,
  Link,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { ISpecialist } from "./redux/types/Types";
import { MdArrowBackIos } from "react-icons/md";
import i18next from "i18next";
import { LanguageKeyTypes } from "../../i18n/types";
import DefaultAvatar from "../../assets/Image/doctor-avatar.jpg";
import { Trans } from "react-i18next";
import { FaWhatsappSquare } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";

interface Props {
  el: ISpecialist;
  bodyHeight?: number;
}
export function DoctorCard({ el, bodyHeight }: Props) {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const currentLang = i18next.language as LanguageKeyTypes;

  function DoctorAvatar() {
    return (
      <Image
        src={el.avatar || DefaultAvatar}
        w="full"
        objectFit="cover"
        height="360px"
        align={"Avatar"}
      />
    );
  }
  return (
    <Flex
      onClick={onOpen}
      py="4"
      px="4"
      gap="3"
      justifyContent="space-between"
      alignItems="center"
      _active={{ bg: "#ededed" }}
      cursor="pointer"
      transition=".2s"
    >
      <Box>
        <Text fontSize="20px" fontWeight="500">
          {el.name}
        </Text>
        <Text
          mt="1"
          fontWeight="400"
          color="rgb(102, 102, 102)"
          lineHeight="20px"
          fontSize="15px"
        >
          {el[`title_${currentLang}`]}
        </Text>
      </Box>

      <Flex gap="4" alignItems="center">
        {!!el.phone && (
          <a onClick={(e) => e.stopPropagation()} href={`tel:${el.phone}`}>
            <FaPhoneAlt fontSize="24px" color="rgb(64, 178, 235)" />
          </a>
        )}
        {!!el.whatsapp && (
          <a
            onClick={(e) => e.stopPropagation()}
            href={`https://wa.me/${el.whatsapp}`}
          >
            <FaWhatsappSquare fontSize="30px" color="#25D366" />
          </a>
        )}
      </Flex>

      <Drawer isOpen={isOpen} onClose={onClose} placement="bottom">
        <DrawerOverlay />
        <DrawerContent
          height={bodyHeight ? `${bodyHeight}px` : "90vh"}
          overflowY="auto"
          pb="6"
          pt="0"
          px="0"
        >
          <DrawerCloseButton
            fontSize="14px"
            top="4"
            left="4"
            bg="white"
            boxShadow="none"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Box ml="1">
              <MdArrowBackIos />
            </Box>
          </DrawerCloseButton>
          <DoctorAvatar />

          <Box px="4" pt="6" mt="-6px" bg="white" roundedTop="10px">
            <Text fontSize="30px" fontWeight="500">
              {el.name}
            </Text>
            <Text mt="2" fontSize="21px" fontWeight="500">
              {el[`title_${currentLang}`]}
            </Text>
            <Text mt="2px" fontSize="17px" fontWeight="400">
              {el[`bio_${currentLang}`]}
            </Text>

            <Flex
              alignItems="center"
              gap="3"
              mt="8"
              pb="5"
              borderBottom="0.5px solid rgba(209, 204, 204, 0.53)"
            >
              <Link
                href={`tel:${el.phone}`}
                rounded="8px"
                px="4"
                h="10"
                py="2"
                display="flex"
                justifyContent="center"
                alignItems="center"
                bg="#0c3752"
                color="white"
                w="50%"
                _active={{ opacity: ".7" }}
              >
                <Trans>callButton</Trans>
              </Link>

              <Link
                href={`https://wa.me/${el.whatsapp}`}
                rounded="8px"
                px="4"
                h="10"
                py="2"
                display="flex"
                justifyContent="center"
                alignItems="center"
                bg="#0c3752"
                color="white"
                w="50%"
                _active={{ opacity: ".7" }}
              >
                Whatsapp
              </Link>
            </Flex>

            <Box mt="3">
              <Text fontSize="17px" fontWeight="400">
                {el.specialist_category[`name_${currentLang}`]}
              </Text>
              <Text mt="1" fontSize="17px" fontWeight="400">
                {el[`workplace_${currentLang}`]}
              </Text>
            </Box>
          </Box>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
